import { ErrorType } from '../models/clux/enum';

export const errorMessageMap: Record<ErrorType, string> = {
  [ErrorType.IndividualNotUniqueEmail]: 'Something went wrong. Enter a different email address.',
  [ErrorType.ExceedsOverallMaximumLimit]: 'Overall plan limit exceeded',
  [ErrorType.ExceedsBenefitPlanEmployerMaximumLimit]: 'Employer plan limit exceeded',
  [ErrorType.ExceedsBenefitPlanEmployeeMaximumLimit]: 'Employee plan limit exceeded',
};
